export { default } from './CanalEtic';
